import React from 'react';
import { useMap } from '../../contexts/MapContext';
import DisplacementLayer from './layers/DisplacementLayer';
import DamageAssessmentLayer from './layers/DamageAssessmentLayer';
import HealthFacilitiesLayer from './layers/HealthFacilitiesLayer';

const DataLayers: React.FC = () => {
  const { selectedDataLayer } = useMap();

  return (
    <>
      {selectedDataLayer === 'displacement' && <DisplacementLayer />}
      {selectedDataLayer === 'damage' && <DamageAssessmentLayer />}
      {selectedDataLayer === 'health' && <HealthFacilitiesLayer />}
    </>
  );
};

export default DataLayers;